// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"ec37724c","676":"00556b1a"}[chunkId] + ".chunk.css";
};